export const removeAria = {
  bind(el, binding) {
    // 获取节点
    let ariaEls = el.querySelectorAll(".el-radio__original");
    ariaEls.forEach((item) => {
      item.removeAttribute("aria-hidden");
    });
  }
};


export const InputTipTop = {
  bind(el, binding) {
    // 获取节点
    //创建input提示
    const span = document.createElement('span')
    const input = el.querySelector('input')
    span.className = 'input-tip'
    span.innerText = binding.value
    el.appendChild(span)
    input.addEventListener('blur', () => {// 失焦时隐藏提示
      span.classList.remove('input-tip-show')
    })
    input.addEventListener('focus', () => {// 聚焦时显示提示
      span.classList.add('input-tip-show')
    })
    // const input = el.querySelector('input')
    console.log(el, binding, "InputTipTop")
    // let ariaEls = el.querySelectorAll(".el-radio__original");
    // ariaEls.forEach((item) => {
    //   item.removeAttribute("aria-hidden");
    // });
  }
};

export const trimInput = {
  bind(el, binding) {
    const input = el.querySelector('input')
    const inputEl = el.querySelector('input');
    if (!inputEl) {
      console.error('v-trim 指令只能用于包含 input 的元素');
      return;
    }
    const trimHandler = () => {
      const trimmedValue = inputEl.value.trim().replace(/^\t+|\t+$/g, '');
      if (trimmedValue !== inputEl.value) {
        // 更新 input 框显示的值
        inputEl.value = trimmedValue;

        // 手动触发 el-input 的 input 事件更新 v-model 绑定值
        const event = new Event('input', { bubbles: true });
        inputEl.dispatchEvent(event);
      }
    };
    // 在失去焦点时触发 trim
    inputEl.addEventListener('blur', trimHandler);

    // 保存处理器到元素属性中，方便解绑
    el._trimHandler = trimHandler;
  },
  unbind(el) {
    // 清理事件绑定
    const { handler, inputEl } = el._trimHandler;
    if (handler && inputEl) {
      inputEl.removeEventListener('blur', handler);
      delete el._trimHandler;
    }
  }
}